import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import DashLayout from "@/layouts/DashLayout";
import RoleProtectedPage from "@/layouts/RoleProtectedPage";
import PageTitle from "@/components/PageTitle";
import Spinner from "@/components/Spinner";
import SessionLedgerTable from "@/components/pos/register/SessionLedgerTable";
import SessionSummary from "@/components/pos/register/SessionSummary";
import { useGetSessionQuery } from "@/redux/services/pos/registerSession.api";
import { useRestaurantCurrency } from "@/lib/hooks";
import { formatDate } from "@/lib/utils";
import { Roles } from "@/redux/services/user/user.type";

const SessionDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const currency = useRestaurantCurrency();

  const {
    data: session,
    isLoading,
    isError,
  } = useGetSessionQuery({ sessionUuid: id! }, { skip: !id });

  return (
    <DashLayout>
      <RoleProtectedPage
        allowedRoles={[Roles.manager, Roles.cashier]}
        allowedPermissions={["cash_register.view"]}
      >
        <div className="space-y-4">
          <Link
            to="/register/sessions"
            className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-card-foreground"
          >
            <ArrowLeft className="h-4 w-4" />
            Retour à l'historique
          </Link>
          <PageTitle
            title={
              session
                ? `Session du ${formatDate(new Date(session.openedAt))}`
                : "Détails de la session"
            }
            description="Récapitulatif et journal des paiements"
          />

          {isLoading && (
            <div className="flex items-center justify-center py-12">
              <Spinner />
            </div>
          )}

          {isError && (
            <div className="flex items-center justify-center py-12">
              <p className="text-destructive">
                Une erreur s'est produite lors du chargement de la session.
              </p>
            </div>
          )}

          {session && (
            <>
              <SessionSummary session={session} currency={currency} />
              <SessionLedgerTable
                sessionId={session.id}
                currency={currency}
              />
            </>
          )}
        </div>
      </RoleProtectedPage>
    </DashLayout>
  );
};

export default SessionDetailPage;
